
import UnAuthedInterceptor from './unauthed-interceptor.factory';
import ResourceActions from './resource-actions.factory';
import PreferenceResource from './preference-resource.factory';
import AccountResource from './account-resource.factory';
import ConnectionSourceResource from './connection-source-resource.factory';
import PlanResource from './plan-resource.factory';
import ProviderAccountResource from './provider-account-resource.factory';
import PendingSheetResource from './pending-sheet-resource.factory';
import SheetResource from './sheet-resource.factory';
import SubscriptionResource from './subscription-resource.factory';
import UserResource from './user-resource.factory';

export const moduleName = 'Tiller.APIServices';
export default {
  moduleName
};

angular.module(moduleName, ['ngResource'])
  .factory('unAuthedInterceptor', UnAuthedInterceptor)
  .factory('resourceActions', ResourceActions)
  .factory('AccountResource', AccountResource)
  .factory('ConnectionSourceResource', ConnectionSourceResource)
  .factory('PendingSheetResource', PendingSheetResource)
  .factory('PlanResource', PlanResource)
  .factory('PreferenceResource', PreferenceResource)
  .factory('ProviderAccountResource', ProviderAccountResource)
  .factory('SheetResource', SheetResource)
  .factory('SubscriptionResource', SubscriptionResource)
  .factory('UserResource', UserResource);

